/**
 * TEMPORARY Seq instrumentation for the "dismissing the rising modal does not
 * dismiss CrisingmodalView" investigation. Every Crisingmodal instance gets a
 * unique uuid so shared-registration-id collisions between instances are
 * visible in the timeline. Remove together with the logging calls in
 * Crisingmodal.tsx once the issue is proven solved.
 */

export const CRISINGMODAL_DISMISS_DEBUG_COMPONENT = 'Crisingmodal/dismiss-debug';
export const CRISINGMODAL_DISMISS_DEBUG_INSTANCE_ID = 'crisingmodal-dismiss--2026-07-06';

export enum CrisingmodalDismissDebugEvent {
  Mounted = 'crisingmodal-mounted',
  Unmounted = 'crisingmodal-unmounted',
  VisibleChanged = 'crisingmodal-visible-changed',
  HandleClose = 'crisingmodal-handle-close',
  HandleBack = 'crisingmodal-handle-back',
  ExitComplete = 'crisingmodal-exit-complete',
}

export enum CrisingmodalDismissDebugBranch {
  OnBack = 'on-back',
  FallbackClose = 'fallback-close',
}
